import { render, staticRenderFns } from "./CreateChild.vue?vue&type=template&id=d7de0ebc&"
import script from "./CreateChild.vue?vue&type=script&lang=js&"
export * from "./CreateChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports